import React from 'react';
import { Form } from 'react-bootstrap'
import QuestionTpl from '../templates/QuestionTpl'
import RangeSlider from './RangeSlider';

export default class DistanceQn extends React.Component {

    static id = 'distance';
    static defaultValue = '30000';

    render() {
        const { id, value, onChange } = this.props;
        
        return (
            <QuestionTpl
                {...this.props}
                title="Distance"
                description="KM's per year"
                fineprint="The average kilometers travelled is between 20,000 - 40,000KMs per year."
                component={RangeSlider}
                componentProps={{
                    key: "distance",
                    value,
                    displayValue: `${value}KM's`,
                    onChange: (e) => onChange(id, e.target.value),
                    min: 5000,
                    max: 60000,
                    step: 1000
                }}
            />
        );
    }
}
